// @ flow
import * as c from '../stores/payments';
import {
  setBraintreePaypalInitialized,
  INITIALIZE_PAYPAL
} from '../stores/payments';
import type { Store } from '../stores/reducer';

type Action = {| type: typeof INITIALIZE_PAYPAL |};

export const actions: { [string]: (any) => Action } = {
  initializePaypal: () => ({ type: INITIALIZE_PAYPAL })
};

export default function braintreeMiddleware(client, braintreeProvider) {
  return (store: Store) => (next: Function) => (action: Action): any => {
    switch (action.type) {
      case INITIALIZE_PAYPAL: {
        const state = store.getState();
        const token = state.payments.braintreeToken;

        // Either load token from API or resolve from the store
        const tokenPromise = !token
          ? client.paymentToken.braintree().then(payload => {
              store.dispatch({ type: c.GET_BRAINTREE_TOKEN_SUCCESS, payload });
              return payload.data.token;
            })
          : new Promise(resolve => resolve(token));

        tokenPromise
          .then(t => braintreeProvider.initBraintreePaypalInstance(t))
          .then(() => {
            store.dispatch(setBraintreePaypalInitialized(true));
          })
          .catch(err => {
            console.log(err);
            store.dispatch({ type: c.GET_BRAINTREE_TOKEN_FAIL });
          });

        break;
      }

      default:
        break;
    }

    return next(action);
  };
}
